// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2lEk7","boxTitle":"Qualiphy_boxTitle__3matc","box":"Qualiphy_box__2VMG0","toggleWrap":"Qualiphy_toggleWrap__21s3g"};